/**
 * ChillGear — US/CA/UK only storefront.
 * Non-target countries (incl. NL) default to US market view.
 */
(function () {
  'use strict';

  var ALLOWED = { US: true, CA: true, GB: true };

  function withCountry(country) {
    var url = new URL(window.location.href);
    url.searchParams.set('country', country);
    return url.pathname + url.search + url.hash;
  }

  function enforceMarketCountry() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('country')) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!country || ALLOWED[country]) return;
        window.location.replace(withCountry('US'));
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-testid="cart-drawer-trigger"]');
    if (!trigger) return;

    setTimeout(function () {
      var drawer = document.getElementById('cart-drawer');
      var themeDrawer = drawer && drawer.querySelector('theme-drawer');
      if (themeDrawer && !themeDrawer.hasAttribute('open') && typeof themeDrawer.open === 'function') {
        themeDrawer.open();
      }
    }, 150);
  }, true);

  enforceMarketCountry();
})();
